import React, { useState } from "react";
import { ReactP5Wrapper } from "@p5-wrapper/react";
import { Slider, Grid, Typography, Stack, Divider, Chip } from "@mui/material";
import createSpirographSketch from "./main/spirographSketch";

function Spirograph() {
  const MAINCIRCDIAM = 500;
  const [internalCircleDiameter, setInternalCircleDiameter] = useState(113);
  const [internalPenDist, setInternalPenDist] = useState(
    internalCircleDiameter / 2
  );
  const [externalCircleDiameter, setExternalCircleDiameter] = useState(113);
  const [externalPenDist, setExternalPenDist] = useState(
    externalCircleDiameter / 2
  );

  const handleInternalPenDistChange = (event, newValue) => {
    setInternalPenDist(newValue);
  };

  const handleInternalCircleChange = (event, newValue) => {
    setInternalCircleDiameter(newValue);
  };

  const handleExternalPenDistChange = (event, newValue) => {
    setExternalPenDist(newValue);
  };
  const handleExternalCircleChange = (event, newValue) => {
    setExternalCircleDiameter(newValue);
  };

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="space-around"
      width="100%"
    >
      <Grid item xs={12} md={6}>
        <Stack margin={5}>
          <Divider>
            <Chip label="Internal" size="small" />
          </Divider>
          <Stack>
            <Typography>Internal Pen Distance</Typography>
            <Slider
              aria-label="Internal Pen Distance"
              value={internalPenDist}
              onChange={handleInternalPenDistChange}
              min={0}
              max={internalCircleDiameter / 2}
              valueLabelDisplay="auto"
              step={0.01}
            />
          </Stack>

          <Stack>
            <Typography>Internal Circle Diameter</Typography>
            <Slider
              aria-label="Internal Circle Diameter"
              value={internalCircleDiameter}
              onChange={handleInternalCircleChange}
              min={0}
              max={MAINCIRCDIAM}
              valueLabelDisplay="auto"
              step={0.01}
            />
          </Stack>
        </Stack>

        <Stack margin={5}>
          <Stack>
            <Divider>
              <Chip label="External" size="small" />
            </Divider>
            <Typography>External Pen Distances</Typography>
            <Slider
              aria-label="External Pen Distance"
              value={externalPenDist}
              onChange={handleExternalPenDistChange}
              min={0}
              max={externalCircleDiameter / 2}
              valueLabelDisplay="auto"
              step={0.01}
            />
          </Stack>
          <Stack>
            <Typography>External Circle Diameter</Typography>
            <Slider
              aria-label="External Circle Diameter"
              value={externalCircleDiameter}
              onChange={handleExternalCircleChange}
              min={0}
              max={MAINCIRCDIAM}
              valueLabelDisplay="auto"
              step={0.01}
            />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <ReactP5Wrapper
          sketch={createSpirographSketch(
            internalPenDist,
            internalCircleDiameter,
            externalPenDist,
            externalCircleDiameter,
            MAINCIRCDIAM
          )}
        />
      </Grid>
    </Grid>
  );
}
export default Spirograph;
